import { UiDefinition } from 'app/infrastructure/ui/types-uidefinition';
import { StoreData, StoreMetadata, CompositeKeys, StoreField, ComplexValue, StoreItemPath } from 'app/types-shared';
import { CaseConnectionParam, CopyDocumentItemOptions } from 'app/infrastructure/ui/form/types';

export const ACTION = {
  REQUEST_DRAFT_DOC: 'DRAFT:REQUEST_DRAFT_DOC',
  RECEIVE_DRAFT_DOC: 'DRAFT:RECEIVE_DRAFT_DOC',
  FAIL_DRAFT_DOC: 'DRAFT:FAIL_DRAFT_DOC',
  ENTER_DRAFT_EDIT: 'DRAFT:ENTER_DRAFT_EDIT',
  LEAVE_DRAFT_EDIT: 'DRAFT:LEAVE_DRAFT_EDIT',
  ADD_DOCUMENT_ITEM: 'DRAFT:ADD_DOCUMENT_ITEM',
  COPY_DOCUMENT_ITEM: 'DRAFT:COPY_DOCUMENT_ITEM',
  DELETE_DOCUMENT_ITEM: 'DRAFT:DELETE_DOCUMENT_ITEM',
  SELECT_DOCUMENT_ITEM: 'DRAFT:SELECT_ITEM',
  ENTER_CONNECTED_DRAFT_EDIT: 'DRAFT:ENTER_CONNECTED_DRAFT_EDIT',
  SHOW_CONFIRM_WARNINGS: 'DRAFT:SHOW_CONFIRM_WARNINGS',
  WARNINGS_CONFIRMED: 'DRAFT:WARNINGS_CONFIRMED',
  TRIGGER_VALIDATION: 'DRAFT:TRIGGER_VALIDATION',
  RECEIVE_UI_DEFINITION: 'DRAFT:RECEIVE_UI_DEFINITION',
  CLEAR_UI_DEFINITION: 'DRAFT:CLEAR_UI_DEFINITION'
};

export class TriggerValidation {
  public type: string = ACTION.TRIGGER_VALIDATION;
}

export class WarningsConfirmed {
  public type: string = ACTION.WARNINGS_CONFIRMED;
  public value: boolean;
  constructor(value = true) {
    this.value = value;
  }
}

export class ShowConfirmWarnings {
  public type: string = ACTION.SHOW_CONFIRM_WARNINGS;

  constructor(public value: boolean = true, public warnings: [] = undefined) { }
}

export class EnterDraftEdit {
  public type: string = ACTION.ENTER_DRAFT_EDIT;
  public id: number;
  public uiDefinition: UiDefinition;
  constructor(id: number, definition: UiDefinition) {
    this.id = id;
    this.uiDefinition = definition;
  }
}

export class CopyDocumentItem {
  public type: string = ACTION.COPY_DOCUMENT_ITEM;
  constructor(
    public documentItemPath: StoreItemPath[],
    public options: CopyDocumentItemOptions
  ) { }
}

export class AddDocumentItem {
  public type: string = ACTION.ADD_DOCUMENT_ITEM;
  public parentKeys: CompositeKeys;
  public entityType: string;
  public childId: number;
  /**
   * `property:value` mapping of any default values to apply to the new entity
   */
  public initialValues: { [indexer: string]: StoreField[] | ComplexValue<number> };

  constructor(
    parentKeys: CompositeKeys,
    entityType: string,
    childId?: number,
    initialValues?: { [indexer: string]: StoreField[] | ComplexValue<number> }
  ) {
    this.parentKeys = parentKeys;
    this.entityType = entityType;
    this.childId = childId;
    this.initialValues = initialValues;
  }
}

export class DeleteDocumentItem {
  public type: string = ACTION.DELETE_DOCUMENT_ITEM;
  public childKey: CompositeKeys;

  constructor(childKey: CompositeKeys) {
    this.childKey = childKey;
  }
}

export class LeaveDraftEdit {
  public type: string = ACTION.LEAVE_DRAFT_EDIT;
}

export class RequestDraftDocument {
  public id: number;
  public type: string = ACTION.REQUEST_DRAFT_DOC;
  constructor(id: number) {
    this.id = id;
  }
}

export class ReceiveDraftDocument {
  public type: string = ACTION.RECEIVE_DRAFT_DOC;
  public draftId: number;
  public data: StoreData;
  public metadata: StoreMetadata;
  public etag: string;
  constructor(draftId: number, data: StoreData, metadata: StoreMetadata, etag: string) {
    this.draftId = draftId;
    this.data = data;
    this.metadata = metadata;
    this.etag = etag;
  }
}

export class FailDraftDocument {
  public type: string = ACTION.FAIL_DRAFT_DOC;
}
export class ChildItemSelection {
  public type: string = ACTION.SELECT_DOCUMENT_ITEM;
  public key: CompositeKeys;
  constructor(key: CompositeKeys) {
    this.key = key;
  }
}

export class EnterConnectedDraftEdit {
  public type: string = ACTION.ENTER_CONNECTED_DRAFT_EDIT;
  constructor(
    public connections: CaseConnectionParam[]
  ) { }
}

export class ReceiveUiDefinition {
  public type: string = ACTION.RECEIVE_UI_DEFINITION;
  constructor(public definition: UiDefinition) { }
}

export class ClearUiDefinition {
  public type: string = ACTION.CLEAR_UI_DEFINITION;
  constructor() { }
}
